import { BigDataObjectConstants } from "../constants/big-data-object-constants";
import { BigData } from "../marketing-client-bigdata";
import { CollectionIdsObject, CtaObject, RegistrationWallObject, Utils } from "../utils/utils";
import { CookieHelper } from "./cookie-helper";

export class BigDataHelper {
  static getBigDataObject(): object | null {
    const [
      mainObjectKey,
      portalObjectKey,
      blueWhaleWrapperKey
    ] = BigDataObjectConstants.bigDataBlueWhaleObject.split(".");

    if (
      window[mainObjectKey] &&
      window[mainObjectKey][portalObjectKey] &&
      window[mainObjectKey][portalObjectKey][blueWhaleWrapperKey]
    ) {
      return window[mainObjectKey][portalObjectKey][blueWhaleWrapperKey];
    }

    return null;
  }

  // static async getBigDataGUID(): Promise<string | null> {
  static getBigDataGUID(): string | null {
    let bigDataVariable = BigDataHelper.getBigDataObject();

    if (Utils.isNullOrUndefined(bigDataVariable)) {
      return null;
    }

    bigDataVariable = bigDataVariable as object;

    const bigDataGUID = bigDataVariable[BigDataObjectConstants.bigDataGUID];

    if (CookieHelper.get(BigDataObjectConstants.bigDataGUIDCookie) !== null || !!bigDataGUID) {
      return CookieHelper.get(BigDataObjectConstants.bigDataGUIDCookie) || bigDataGUID;
    }

    return null;
  }

  static getBigDataGWGUID(): string {
    if (window[BigDataObjectConstants.bigDataSiteDetails]) {
      return window[BigDataObjectConstants.bigDataSiteDetails].gwguid;
    }
    return '';
  }

  static getBigDataGWEMID(): string {
    if (window[BigDataObjectConstants.bigDataSiteDetails]) {
      return window[BigDataObjectConstants.bigDataSiteDetails].gwemid;
    }
    return '';
  }

  static getBigDataOrCookieValue(cookieKey: string, bigDataKey: string): string {
    const cookieValue = CookieHelper.get(cookieKey);

    let bigDataObject = BigDataHelper.getBigDataObject(),
      bigDataValue = null;

    if (!Utils.isNullOrUndefined(bigDataObject)) {
      bigDataObject = bigDataObject as object;
      bigDataValue = bigDataObject[bigDataKey];
    }

    if (!Utils.isNullOrUndefined(cookieValue) || !Utils.isNullOrUndefined(bigDataValue)) {
      return cookieValue || bigDataValue;
    }

    return "";
  }

  static createAttribute(element: Element | HTMLElement, isUtilization = false, clickID: string = ""): Attribute {
    const htmlElement = isUtilization ? element : element.parentElement,
      collectionIdsObject: CollectionIdsObject = htmlElement && Utils.prepareCollectionIdsObject(htmlElement) || {},
      ctaObject: CtaObject = htmlElement && Utils.prepareCtaObject(htmlElement) || {},
      rwObject: RegistrationWallObject = htmlElement && Utils.prepareRegistrationWallObject(htmlElement) || {};

    return BigData.prepareDataOceanAttribute(ctaObject, collectionIdsObject, rwObject, clickID)
  }
}

export interface Attribute {
  actionId?: string;
  articleCounter?: string;
  campaignId?: string;
  cta?: string;
  ctaCategory?: string;
  guid?: string;
  pageViewId?: string;
  stage?: string;
  stageEndDate?: string;
  touchPointId?: string;
  visitId?: string;
  clickID?: string;
}